(function () {
  const sliders = document.querySelectorAll('.js-image-slider-about');
  if (sliders.length === 0) return;

  const MOBILE_MAX = 640;
  const isMobile = () => window.innerWidth <= MOBILE_MAX;

  const controllers = [];

  sliders.forEach((slider) => {
    const allSlides = Array.from(slider.querySelectorAll('.slide'));
    if (allSlides.length === 0) return;

    const prevButton = slider.querySelector('.prev-button');
    const nextButton = slider.querySelector('.next-button');

    let activeSlides = [];
    let currentIndex = 0;

    function render() {
      if (activeSlides.length === 0) {
        slider.style.display = 'none';
        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
        return;
      }
      slider.style.display = '';
      if (prevButton) prevButton.style.display = '';
      if (nextButton) nextButton.style.display = '';
      activeSlides.forEach((slide, i) => {
        slide.style.display = i === currentIndex ? 'block' : 'none';
      });
    }

    function buildActiveSet() {
      const mobile = isMobile();
      activeSlides = allSlides.filter((slide) =>
        mobile
          ? slide.dataset.showMobile !== 'false'
          : slide.dataset.showDesktop !== 'false'
      );
      // Hide every slide first so ineligible ones never linger visible.
      allSlides.forEach((slide) => { slide.style.display = 'none'; });
      // Clamp the index to the new active range after a breakpoint switch.
      if (currentIndex > activeSlides.length - 1) {
        currentIndex = Math.max(0, activeSlides.length - 1);
      }
      render();
    }

    function next() {
      if (activeSlides.length < 2) return;
      currentIndex = (currentIndex + 1) % activeSlides.length;
      render();
    }

    function prev() {
      if (activeSlides.length < 2) return;
      currentIndex = (currentIndex - 1 + activeSlides.length) % activeSlides.length;
      render();
    }

    if (prevButton) prevButton.addEventListener('click', prev);
    if (nextButton) nextButton.addEventListener('click', next);

    let startX, startY, distX, distY, isSwiping = false;

    slider.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      isSwiping = false;
    });

    slider.addEventListener('touchmove', (e) => {
      if (!startX || !startY) return;
      const touch = e.touches[0];
      distX = touch.clientX - startX;
      distY = touch.clientY - startY;
      if (Math.abs(distX) > Math.abs(distY)) {
        isSwiping = true;
      }
    });

    slider.addEventListener('touchend', () => {
      if (isSwiping) {
        if (distX < 0) {
          next();
        } else if (distX > 0) {
          prev();
        }
      }
      startX = startY = distX = distY = isSwiping = 0;
    });

    buildActiveSet();

    controllers.push({ recompute: buildActiveSet });
  });

  let lastIsMobile = isMobile();
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const mobileNow = isMobile();
      if (mobileNow === lastIsMobile) return;
      lastIsMobile = mobileNow;
      controllers.forEach((c) => c.recompute());
    }, 150);
  });
})();
